import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {
  FastAPIServiceError,
  UserInitiatePayload,
  UserInitiateResponse,
} from '@guestapp/sdk';
import {useIsMounted} from '../common';
import {useChekinSDK} from 'context/ChekinSDK';

type Props = UseMutationOptions<
  UserInitiateResponse,
  FastAPIServiceError,
  UserInitiatePayload
>;
function useInitUserAccountMutation({onError, ...options}: Props = {}) {
  const {initiateUser} = useChekinSDK();

  const isMounted = useIsMounted();

  return useMutation<UserInitiateResponse, FastAPIServiceError, UserInitiatePayload>(
    payload => initiateUser(payload),
    {
      onError: (error, data, variables) => {
        if (!isMounted.current) {
          return;
        }

        onError?.(error, data, variables);
      },
      ...options,
    },
  );
}

export {useInitUserAccountMutation};
